import { Routes } from '@angular/router';

import { isUserAuthentcatedRoutesGuard } from './services/isUserAuthentcated-routes-guard.service';
import { RoleBasedRouting } from './components/main/roleBasedRouting.component';
import { ExternalRoutesGuard } from './services/external-routes-guard.service';
import { Learner } from './../learner/components/main/learner.component';
import { Teacher } from './../teacher/components/main/teacher.component';

export const ROUTES: Routes = [
  
    {
      path: '', component: RoleBasedRouting, canActivate: [isUserAuthentcatedRoutesGuard]
    },
    {
      path: 'learner', component: Learner
    },
    {
      path: 'teacher', component: Teacher
    },
    {
      path: 'externalRedirect' , canActivate: [ExternalRoutesGuard],
      component: RoleBasedRouting,
    },
    {
      path: '**', redirectTo: '', pathMatch: 'full'
    }
];
